import axios from 'axios';
import { getCdnBasePath } from './paths';
import loadFiles from '../helpers/file-loader';

/**
 * Retrieves mds svg icons and adds them to the dom
 * @param  {*} mds - Contains the mds configuration
 * @param  {*} componentSourceEnvironment - Contains information on where to retrieve icons
 * @returns {Promise} - Resolves with the loader configuration
 */
function mdsIconsReady(mds, componentSourceEnvironment) {
    return new Promise((resolve) => {
        const { icons, version } = mds;

        if (!icons || !version) {
            return resolve();
        }
        const iconTemplate = document.createElement('mds-icons');
        iconTemplate.id = 'mds-svg-icons';
        iconTemplate.style.display = 'none';

        const insertSVG = function insertSVG() {
            document.body.insertBefore(iconTemplate, document.body.childNodes[0]);
        };

        if (!document.body) {
            document.addEventListener('DOMContentLoaded', insertSVG);
        } else {
            insertSVG();
        }

        return axios({
            method: 'get',
            url: `${getCdnBasePath(componentSourceEnvironment)}mc/morningstar-design-system/${version}/dist/mds.svg`,
            validateStatus: null,
        })
            .then((axiosReturnObject) => {
                iconTemplate.innerHTML = axiosReturnObject.data;
                resolve();
            });
    });
}

function mdsCssReady(mds, componentSourceEnvironment) {
    return new Promise((resolve) => {
        const { style, version } = mds;

        if (!style || !version) {
            return resolve();
        }

        const mdsCss = `${getCdnBasePath(componentSourceEnvironment)}mc/morningstar-design-system/${version}/dist/mds.css`;

        return loadFiles([mdsCss])
            .then(() => resolve());
    });
}

export {
    mdsIconsReady,
    mdsCssReady,
};



// WEBPACK FOOTER //
// ../loader-base/src/services/mds-loader.js